import { READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useCallback, useEffect, useRef, useState } from 'react'

import Button from '../../../components/Button/Button'
import { Form } from '../../../components/Form/Form'
import Modal from '../../../components/Modal/Modal'
import ModalContent from '../../../components/Modal/ModalContent'
import ModalFooter from '../../../components/Modal/ModalFooter'
import ModalHeader from '../../../components/Modal/ModalHeader'
import PhotoUploader from '../../../components/PhotoUploader/PhotoUploader'
import TextField from '../../../components/TextField/TextField'
import { post } from '../../../helpers/request'
import t from '../../../helpers/i18n'
import { useParams } from 'react-router-dom'

const emailValidation = (text) =>
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(text)
    ? false
    : t('validations.invalid_email')
const phoneValidation = (text) =>
  /^.{1,20}$/.test(text)
    ? false
    : t('validations.phone_number_is_invalid')

const PlayerFormModal = ({ onCloseRequested }) => {
  const [formValid, setFormValid] = useState(false)
  const createPlayerData = useRef()
  const createPlayerPending = useRef()
  const [[playerState], setPlayer] = useVisualState()
  const { clubId, teamId } = useParams()

  const handleCreatePlayer = useCallback(() => {
    post(
      '/soccer/clubs/' + clubId + '/teams/' + teamId + '/players/new',
      createPlayerData.current
    )
      .then((response) => {
        onCloseRequested()
      })
      .catch((error) => {
        console.log(error)
      })
  }, [clubId, teamId, onCloseRequested])

  useEffect(() => {
    setPlayer(READY, {})
  }, [setPlayer])

  return (
    <div>
      {playerState === READY && (
        <Modal onCloseRequested={onCloseRequested}>
          <ModalHeader title={t('modal_headers.Add_new_player')} />
          <ModalContent>
            <Form
              data={createPlayerData}
              pending={createPlayerPending}
              onValidityChange={setFormValid}
            >
              <div className='-band'>{t('titles.Personal')}</div>
              <div className='-layout-21'>
                <div>
                  <TextField
                    name='firstname'
                    label={t('labels.First_Name')}
                    maxLength={100}
                    minLength={2}
                    required
                  />
                  <TextField
                    name='lastname'
                    label={t('labels.Last_Name')}
                    maxLength={100}
                    minLength={2}
                    required
                  />
                </div>
                <div>
                  <PhotoUploader
                    name="avatar"
                    label={t('labels.Pic')}
                    aspect={1}
                    circular
                  />
                </div>
              </div>
              <TextField
                name='nickname'
                label={t('labels.Nickname')}
                maxLength={50}
                minLength={2}
              />
              <TextField
                name='birthdate'
                label={t('labels.Birthdate')}
                placeholder={t('placeholders.YYYY-mm-dd')}
                maxLength={10}
                minLength={10}
                required
              />
              <div className='-band'>{t('titles.Contact')}</div>
              <TextField
                name='email'
                label={t('labels.Email')}
                onValidation={emailValidation}
                required
              />
              <TextField
                name='phone'
                label={t('labels.Contact_phone')}
                onValidation={phoneValidation}
                maxLength={50}
              />
            </Form>
          </ModalContent>
          <ModalFooter>
            <div>
              <Button label={t('buttons.Cancel')} />
            </div>
            <div>
              <Button
                disabled={!formValid}
                onClick={handleCreatePlayer}
                label={t('buttons.Save')}
              />
            </div>
          </ModalFooter>
        </Modal>
      )}
    </div>
  )
}

export default PlayerFormModal
